/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "AMCommonSaleTopBanner" }] */

import AMCommonGenericCountdown from 'html/include/pw/_common/generic_countdown';
import { sendGoogleEvent, byUserInteraction } from '@html/_common/utils';

export default function AMCommonSaleTopBannerES6(bannerSelector) {
  const EVENT_CATEGORY = 'Sales banner';
  const EVENT_ACTION_IMPRESSION = 'Impression - ';
  const EVENT_ACTION_CLICK = 'Click - ';
  const EVENT_LABEL = 'Banner';

  let bannerTitle;

  const onClickBanner = () => {
    sendGoogleEvent(
      EVENT_CATEGORY,
      EVENT_ACTION_CLICK + bannerTitle,
      window.location.pathname,
      { ampEventName: 'banner_top_clicked' },
    );
  };

  this.initiate = () => {
    const $banner = $(bannerSelector);

    if (!$banner.length) return;
    bannerTitle = $banner.data('title') || '';

    sendGoogleEvent(
      EVENT_CATEGORY,
      EVENT_ACTION_IMPRESSION + bannerTitle,
      EVENT_LABEL,
      { nonInteraction: true, ampEventName: 'banner_top_impression' },
    );

    const hasClickableLink = !!$banner.attr('href');
    if (hasClickableLink) {
      $banner.on('click', onClickBanner);
    }

    byUserInteraction('sale-banner-initiate', () => {
      const countdown = new AMCommonGenericCountdown(bannerSelector);
      setTimeout(() => {
        countdown.initiate();
      }, 1000);
    });
  };
}
